/* eslint-disable no-shadow */
import { Box, Button } from '@mui/material'
import React from 'react'
import { Timestamp } from '@firebase/firestore'
import CustomTextField from '../../../../components/forms/custom-elements/CustomTextField'
import CustomFormLabel from '../../../../components/forms/custom-elements/CustomFormLabel'
import { useTags } from '../../../../utils/context/tags/TagsContext'

export default function TagForm() {
  const tagNameRef = React.useRef()
  const [tagName, setTagName] = React.useState('');

  const { createTags, loading} = useTags();

  const handleSubmit = async (e, tagNameRef, setTagName) => {
    e.preventDefault();

    // Disallow multiple clicks
    if (loading) {
      return;
    }

    // Check for empty input
    if (tagNameRef.current.value === '') {
      return;
    }

    // Add the value
    const newTag = {
      tagName: tagNameRef.current.value,
      dateCreated: Timestamp.fromDate(new Date()),
      tagId: '',
    };

    // TODO: Add code to add newTag to your database or API
    await createTags(newTag);

    // Clear the input field
    setTagName('');

  };

  return (
    <Box>
      <CustomFormLabel htmlFor="tagName">Tag Name</CustomFormLabel>
      <CustomTextField
        id="tagName"
        variant="outlined"
        fullWidth
        size="small"
        label="Enter Tag name"
        inputRef={tagNameRef}
        helperText="Example: Snacks, Drinks, etc."
        value={tagName}
        onChange={(e) => setTagName(e.target.value)}
      />

      <Button
        onClick={
          (e) => {
            handleSubmit(e, tagNameRef, setTagName)
          }
        }
        variant="contained"
        color="primary"
        size="small"
        sx={{ mt: 2 }}
        disabled={loading}
      >
        {loading ? 'Loading...' : 'Add Tag'}
      </Button>
    </Box>
  );
}
